import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, setAuthToken } from "@/App";

export default function AuthCompletePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  const token = searchParams.get("token");
  const authError = searchParams.get("error");
  const errorDetail = searchParams.get("detail");
  const nextPath = searchParams.get("next");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    if (authError) {
      const msg = authError === "invalid_state" ? "Session expired. Please try again." 
        : errorDetail ? `${authError}: ${errorDetail}` 
        : `Sign-in error: ${authError}`;
      setError(msg);
      return;
    }

    if (token) {
      setAuthToken(token);
      // Fetch user data with the token
      const fetchUser = async () => {
        try {
          const res = await axios.get(`${API}/auth/me`);
          localStorage.setItem("dynastydeal_user", JSON.stringify(res.data));
          const dest = nextPath && nextPath.startsWith("/") && !nextPath.startsWith("//") ? nextPath : "/";
          window.location.replace(dest);
        } catch (e) {
          setError("Failed to load your account. Please try again.");
        }
      };
      fetchUser();
      return;
    }

    // No token or error
    navigate("/", { replace: true });
  }, [token, authError, nextPath, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="text-center max-w-sm px-4">
          <p className="text-[#ff6b6b] text-lg font-bold mb-2">Sign-in failed</p>
          <p className="text-[#a3a3a3] text-sm mb-6">{error}</p>
          <div className="flex flex-col gap-3">
            <button onClick={() => { window.location.href = "/api/auth/google/login"; }} className="h-10 px-6 bg-[#ccff00] text-black font-bold text-sm rounded-sm hover:bg-[#b8e600]">TRY AGAIN</button>
            <button onClick={() => navigate("/", { replace: true })} className="text-xs text-[#888] hover:text-white">Go to homepage</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#ccff00] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#a3a3a3] text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
